import {
  Group,
  Paper,
  ScrollArea,
  Stack,
  Text,
} from '@mantine/core'
import { TicketCard } from './TicketCard'
import { Ticket } from '@data/tickets/model/ticket'
import { LucideIcon } from 'lucide-react'

interface CategorySectionProps {
  title: string;
  icon: LucideIcon;
  tickets: Ticket[];
  onTicketClick: (ticket: Ticket) => void;
  color: string;
}

export const CategorySection= ({
                                 title,
                                 icon: Icon,
                                 tickets,
                                 onTicketClick,
                                 color,
                               }: CategorySectionProps) => {
  return (
    <Paper shadow={'sm'} p={'md'} radius={'md'} withBorder>
      <Group mb={'md'} pb={'md'} style={{ borderBottom: '1px solid #e9ecef' }}>
        <div
          style={{
            padding: '0.5rem',
            borderRadius: '0.5rem',
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon size={20} color={'white'} />
        </div>
        <div>
          <Text fw={600}>{title}</Text>
          <Text size={'xs'} c={'dimmed'}>
            {tickets.length} tickets
          </Text>
        </div>
      </Group>

      <ScrollArea h={600}>
        <Stack gap={'md'}>
          {tickets.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              <Text size={'sm'} c={'dimmed'}>
                No tickets in this category
              </Text>
            </div>
          ) : (
            tickets.map((ticket) => (
              <TicketCard
                key={ticket.id}
                ticket={ticket}
                onClick={() => onTicketClick(ticket)}
              />
            ))
          )}
        </Stack>
      </ScrollArea>
    </Paper>
  )
}
